import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebaseConfig';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';

export default function Profile() {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const user = auth.currentUser;
        if (user) {
            const userRef = ref(db, 'users/' + user.uid);
            onValue(userRef, (snapshot) => {
                const data = snapshot.val();
                setUserData(data);
                setLoading(false);
            });
        } else {
            navigate('/login');
        }
    }, [navigate]);

    // Tarih formatlama (Örn: 25 Mart 2026)
    const formatDate = (dateString) => {
        if (!dateString) return "Belirsiz";
        const date = new Date(dateString);
        return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
    };

    // Kalan gün hesaplama
    const getRemainingDays = (expiryDate) => {
        if (!expiryDate) return 0;
        const today = new Date();
        const end = new Date(expiryDate);
        const diffTime = end - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays > 0 ? diffDays : 0;
    };

    // --- PAYTR ÖDEME BAŞLATMA FONKSİYONU ---
    const handlePurchase = async (plan, price) => {
        const user = auth.currentUser;
        
        if (!user || !userData) {
            alert("Kullanıcı verileri yüklenemedi, lütfen sayfayı yenileyin.");
            return;
        }

        const functions = getFunctions(undefined, 'us-central1');
        const getPaytrToken = httpsCallable(functions, 'getPaytrToken');

        try {
            // Sepet içeriği (Backend'in beklediği format)
            const basket = JSON.stringify([[plan, price.toString(), 1]]);

            const result = await getPaytrToken({
                userId: user.uid,
                planName: plan,
                email: userData.email,
                totalAmount: price, 
                userName: userData.adSoyad || "Değerli Meslektaşımız",
                userBasket: basket,
                ip: "1.1.1.1" 
            });

            if (result.data && result.data.token) {
                // Başarılı: PayTR Güvenli Ödeme Sayfasına yönlendir
                window.location.href = `https://www.paytr.com/odeme/guvenli/${result.data.token}`;
            } else {
                alert("Ödeme anahtarı alınamadı: " + (result.data?.err_msg || "PayTR geçersiz istek hatası."));
            }
        } catch (error) {
            console.error("Ödeme Hatası:", error);
            alert("Sistem şu an meşgul, lütfen daha sonra tekrar deneyin.");
        }
    };

    if (loading) return <div style={{ textAlign: 'center', padding: '80px', color: '#2c3e50', fontSize: '15px' }}>Profil verileri alınıyor...</div>;

    const remainingDays = getRemainingDays(userData?.subscription_expiry);
    const isExpiringSoon = remainingDays < 5;

    return (
        <div style={containerStyle}>
            {/* KULLANICI BİLGİ KARTI */}
            <div style={cardStyle}>
                <div style={avatarCircle}>{userData?.adSoyad?.charAt(0).toUpperCase()}</div>
                <h2 style={{ color: '#2c3e50', margin: '12px 0 5px 0', wordBreak: 'break-word', fontSize: '22px' }}>{userData?.adSoyad}</h2>
                <p style={{ color: '#7f8c8d', margin: '0 0 20px 0', wordBreak: 'break-all', fontSize: '14px' }}>{userData?.email}</p>

                <div style={statusBox}>
                    <div style={statusItem}>
                        <span style={statusLabel}>Abonelik Bitiş:</span>
                        <span style={statusValue}>{formatDate(userData?.subscription_expiry)}</span>
                    </div>
                    <div style={statusItem}>
                        <span style={statusLabel}>Kalan Süre:</span>
                        <span style={{ ...statusValue, color: isExpiringSoon ? '#e74c3c' : '#27ae60' }}>
                            {remainingDays} Gün
                        </span>
                    </div>
                </div>

                <div style={buttonGroupStyle}>
                    <button onClick={() => navigate('/change-password')} style={profileButtonStyle}>🔒 Şifremi Değiştir</button>
                    <button onClick={() => navigate('/change-name')} style={profileButtonStyle}>✏️ İsmimi Değiştir</button>
                </div>
            </div>

            {/* ABONELİK PAKETLERİ */}
            <h3 style={{ textAlign: 'center', color: '#2c3e50', marginTop: '45px', marginBottom: '25px', fontSize: '22px' }}>
                Abonelik Paketleri
            </h3>

            <div style={pricingContainer}>
                {/* 1 AYLIK - BAŞLANGIÇ */}
                <div style={priceCard}>
                    <div>
                        <div style={{ fontSize: '36px', marginBottom: '8px' }}>🥉</div>
                        <h4 style={{ margin: '0', color: '#7f8c8d', fontSize: '14px' }}>Başlangıç</h4>
                        <h3 style={{ margin: '8px 0', color: '#2c3e50', fontSize: '18px' }}>1 Aylık</h3>
                        <h2 style={{ color: '#27ae60', margin: '8px 0', fontSize: '26px' }}>69,9 TL</h2>
                        <p style={monthlyPriceLabel}>69,9 TL / ay</p>
                        <ul style={featureList}>
                            <li>✅ 30 Gün Tam Erişim</li>
                            <li>✅ Web + Mobil Kullanım</li>
                            <li>✅ Tüm Hesaplama Araçları</li>
                        </ul>
                    </div>
                    <button onClick={() => handlePurchase('1 Aylık', 69.9)} style={buyBtn}>
                        Satın Al
                    </button>
                </div>

                {/* 3 AYLIK - AVANTAJLI */}
                <div style={priceCard}>
                    <div>
                        <div style={{ fontSize: '36px', marginBottom: '8px' }}>🥈</div>
                        <h4 style={{ margin: '0', color: '#7f8c8d', fontSize: '14px' }}>Avantajlı</h4>
                        <h3 style={{ margin: '8px 0', color: '#2c3e50', fontSize: '18px' }}>3 Aylık</h3>
                        <h2 style={{ color: '#2980b9', margin: '8px 0', fontSize: '26px' }}>169,9 TL</h2>
                        <p style={{ ...monthlyPriceLabel, color: '#2980b9', fontWeight: 'bold' }}>56,6 TL / ay</p>
                        <ul style={featureList}>
                            <li>✅ 90 Gün Tam Erişim</li>
                            <li>🔥 <strong>%19 Tasarruf Avantajı</strong></li>
                            <li>✅ Kesintisiz Klinik Destek</li>
                        </ul>
                    </div>
                    <button onClick={() => handlePurchase('3 Aylık', 169.9)} style={buyBtn}>
                        Satın Al
                    </button>
                </div>

                {/* 12 AYLIK - PROFESYONEL */}
                <div style={priceCardFeatured}>
                    <div>
                        <div style={badge}>EN POPÜLER</div>
                        <div style={{ fontSize: '36px', marginBottom: '8px' }}>🥇</div>
                        <h4 style={{ margin: '0', color: '#fff', opacity: 0.9, fontSize: '14px' }}>Profesyonel</h4>
                        <h3 style={{ margin: '8px 0', color: '#fff', fontSize: '18px' }}>12 Aylık</h3>
                        <h2 style={{ color: '#fff', margin: '8px 0', fontSize: '30px' }}>569,9 TL</h2>
                        <p style={{ ...monthlyPriceLabel, color: '#fff', fontWeight: 'bold' }}>Sadece 47,5 TL / ay</p>
                        <ul style={{ ...featureList, color: 'white' }}>
                            <li>✅ 365 Gün Tam Erişim</li>
                            <li>🔥 <strong>%32 Net Kazanç</strong></li>
                            <li>✅ Fiyat Artışından Etkilenme</li>
                            <li>⭐ En Avantajlı Seçenek</li>
                        </ul>
                    </div>
                    <button onClick={() => handlePurchase('12 Aylık', 569.9)} style={buyBtnWhite}>
                        Hemen Başla
                    </button>
                </div>
            </div>
        </div>
    );
}

// --- CSS STİLLERİ (Üst Menü Çakışmasını Önleyen ve Ferah Düzen) ---
const containerStyle = { 
    maxWidth: '1000px', 
    margin: '0 auto', 
    padding: '35px 15px 70px 15px',
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(40px, env(safe-area-inset-top))', // Üst menüyle çakışmayı önlemek için üst boşluk artırıldı
    paddingBottom: 'max(70px, env(safe-area-inset-bottom))'
};

const cardStyle = { 
    background: 'white', 
    padding: '35px 20px', 
    borderRadius: '18px', 
    boxShadow: '0 10px 30px rgba(0,0,0,0.07)', 
    textAlign: 'center',
    boxSizing: 'border-box',
    width: '100%',
    marginTop: '15px'
};

const avatarCircle = { 
    width: '80px', 
    height: '80px', 
    background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)', 
    color: 'white', 
    borderRadius: '50%', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    fontSize: '32px', 
    margin: '0 auto', 
    fontWeight: 'bold', 
    boxShadow: '0 6px 15px rgba(52, 152, 219, 0.3)' 
};

const statusBox = { 
    background: '#f8f9fa', 
    padding: '18px', 
    borderRadius: '12px', 
    marginTop: '22px', 
    display: 'flex', 
    justifyContent: 'space-around', 
    flexWrap: 'wrap', 
    gap: '15px', 
    boxSizing: 'border-box' 
};

const statusItem = { display: 'flex', flexDirection: 'column', alignItems: 'center' };
const statusLabel = { fontSize: '11px', color: '#95a5a6', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' };
const statusValue = { fontSize: '16px', color: '#2c3e50', fontWeight: 'bold', marginTop: '5px' };

const buttonGroupStyle = { 
    display: 'flex', 
    justifyContent: 'center', 
    gap: '12px', 
    marginTop: '22px', 
    flexWrap: 'wrap', 
    boxSizing: 'border-box' 
};

const profileButtonStyle = { 
    padding: '11px 20px', 
    background: '#ecf0f1', 
    border: 'none', 
    borderRadius: '8px', 
    cursor: 'pointer', 
    fontWeight: 'bold', 
    color: '#2c3e50', 
    fontSize: '13px',
    WebkitTapHighlightColor: 'transparent'
};

const pricingContainer = { 
    display: 'flex', 
    justifyContent: 'center', 
    gap: '25px', 
    flexWrap: 'wrap', 
    alignItems: 'stretch',
    boxSizing: 'border-box',
    width: '100%',
    marginTop: '10px'
};

const priceCard = { 
    background: 'white', 
    padding: '28px 20px', 
    borderRadius: '18px', 
    boxShadow: '0 8px 24px rgba(0,0,0,0.06)', 
    width: '100%', 
    maxWidth: '290px', 
    textAlign: 'center', 
    border: '1px solid #eaeaea', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'space-between',
    boxSizing: 'border-box'
};

const priceCardFeatured = { 
    background: 'linear-gradient(135deg, #2c3e50 0%, #4ca1af 100%)', 
    padding: '28px 20px', 
    borderRadius: '18px', 
    boxShadow: '0 14px 32px rgba(44, 62, 80, 0.22)', 
    width: '100%', 
    maxWidth: '310px', 
    textAlign: 'center', 
    color: 'white', 
    position: 'relative', 
    border: '2px solid rgba(255,255,255,0.25)', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    marginTop: '10px'
};

const badge = { 
    position: 'absolute', 
    top: '-13px', 
    right: '50%', 
    transform: 'translateX(50%)', 
    background: '#e74c3c', 
    color: 'white', 
    padding: '5px 15px', 
    borderRadius: '20px', 
    fontSize: '11px', 
    fontWeight: 'bold', 
    boxShadow: '0 4px 10px rgba(231, 76, 60, 0.4)',
    letterSpacing: '0.5px'
};

const featureList = { 
    listStyle: 'none', 
    padding: 0, 
    textAlign: 'left', 
    margin: '20px 0', 
    fontSize: '13px', 
    lineHeight: '2.1', 
    boxSizing: 'border-box' 
};

const buyBtn = { 
    width: '100%', 
    padding: '13px', 
    background: '#ecf0f1', 
    color: '#2c3e50', 
    border: 'none', 
    borderRadius: '10px', 
    cursor: 'pointer', 
    fontWeight: 'bold', 
    marginTop: '15px',
    fontSize: '14px',
    WebkitTapHighlightColor: 'transparent',
    boxSizing: 'border-box'
};

const buyBtnWhite = { 
    width: '100%', 
    padding: '13px', 
    background: 'white', 
    color: '#2c3e50', 
    border: 'none', 
    borderRadius: '10px', 
    cursor: 'pointer', 
    fontWeight: 'bold', 
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)', 
    marginTop: '15px',
    fontSize: '14px',
    WebkitTapHighlightColor: 'transparent',
    boxSizing: 'border-box'
};

const monthlyPriceLabel = { fontSize: '13px', color: '#95a5a6', marginTop: '-6px', marginBottom: '12px' };